import Select from 'components/form/Inputs/Select';
import React, { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-width: 7rem;
  max-width: 10rem;
  margin-left: auto;
  margin-right: 0;
  /* margin-top: 2rem; */
`;

type Props = {
  take: number;
  setTake: (take: number) => void;
};

const TakeSelect: FC<Props> = ({ take, setTake }) => {
  const handleSelect: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    setTake(+e.target.value);
  };

  return (
    <Container>
      <Select
        value={'' + take}
        onChange={handleSelect}
        label="Nombre de lignes"
      >
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="300">300</option>
        <option value="500">500</option>
      </Select>
    </Container>
  );
};

export default TakeSelect;
